import './ccf-badge.module.scss';
import { Theme, Badge, BadgeProps } from '@mui/material';
import { withStyles } from '@mui/styles';

export interface CcfBadgeProps extends Omit<BadgeProps, ''> {
  label?: string;
  color?: any;
}

/**
 * Component used to display Badge styles
 * @param theme - Theme
 * @example <BadgeStyles />
 * @returns Badge styles
 */
const BadgeStyles = (theme: Theme) => ({
  badge: (props: CcfBadgeProps) => ({
    backgroundColor: props.color||'primary',
  }),
});

/**
 * Badge generates a small badge to the top-right of its child(ren).
 * @param color - To add color to the badge
 * @param label - To define the aria-label
 * @param overlap - Wrapped shape the badge should overlap.
 * @param anchorOrigin - The anchor of the badge.
 * @example <CcfBadge label='example'/>
 */
const BadgeComponent = ({ label, children,color, ...rest }: CcfBadgeProps) => (
  <Badge
    aria-label={label}
    color ={color}
    overlap={rest.overlap || 'circular'}
    anchorOrigin={
      rest.anchorOrigin || {
        vertical: 'top',
        horizontal: 'right',
      }
    }
    {...rest}
  >
    {children}
  </Badge>
);

export const CcfBadge = withStyles(BadgeStyles, { name: 'ccf-badge' })(
  BadgeComponent
);
